import React from 'react';
import { Location, Bus, Fin, Start } from '../Icons/CustomIcons';


const OeVConnectionDisplay = ({ travelLoading, travelError, travelPlan, isCoordinateOnlyLocation, sbbHref }) => {
  return (
    <div className="anreise-container">
    
      {travelLoading && <p>Verbindung wird gesucht...</p>}

      {travelError && (
        <p style={{ color: '#d32f2f' }}>{travelError}</p>
      )}

      {travelPlan && !travelLoading && (
        <>
          {/* Header */}
          <div className="anreise-oev-header">
            <div className="anreise-oev-header-text">
              <h2 className="Font-L-S-130-T Colors-Black">Anreise mit ÖV</h2>
              <p className="Font-S-B-130-T Colors-Grey-06">Empfohlene Verbindung und Dauer</p>
            </div>
            <span className="Font-S-S-130-T Colors-Accent-02 anreise-oev-header-transfers">Umstiege: {travelPlan.transfers}</span>          
          </div>

          {/* Timeline */}
          <div className="timeline">

          {/* Startadresse */}
          {travelPlan.from_address && (
            <div className="timeline-item">
              <div className="timeline-icon">
                <Location size={20} />
              </div>
              <div className="timeline-line" />
              <div className="timeline-content">
                <span className="Font-S-B-130-T Colors-Grey-06">Startadresse</span>
                <p className="Font-M-I-130-T Color-Black">{travelPlan.from_address}</p>
                <p className="timeline-meta Font-S-B-130-T Colors-Grey-06">Ihr Standort</p>
              </div>
            </div>
          )}

          {/* Von (Einstiegshaltestelle) */}
          <div className="timeline-item">
            <div className="timeline-icon">
              <Location size={20} />
            </div>
            <div className="timeline-line" />
            <div className="timeline-content">
              <span className="Font-S-B-130-T Colors-Grey-06">Einsteigen</span>
              <p className="Font-M-I-130-T Color-Black">{travelPlan.from_station}</p>
              <p className="timeline-meta Font-S-B-130-T Colors-Grey-06">
                Haltestelle
                <span className="timeline-divider">|</span>
                Abfahrt: <strong>{new Date(travelPlan.departure).toLocaleString('de-CH', { hour: '2-digit', minute: '2-digit' })}</strong>
              </p>
            </div>
          </div>

          {/* Nach */}
          <div className="timeline-item">
            <div className="timeline-icon">
              <Start size={20} />
            </div>
            <div className="timeline-line" />
            <div>
              <div className="timeline-content">
                <span className="Font-S-B-130-T Colors-Grey-06">Nach</span>
                <p className="Font-M-I-130-T Color-Black">{travelPlan.to_station}</p>
                <p className="timeline-meta Font-S-B-130-T Colors-Grey-06">
                  Haltestelle
                  <span className="timeline-divider">|</span>
                  Ankunft: <strong>{new Date(travelPlan.arrival).toLocaleString('de-CH', { hour: '2-digit', minute: '2-digit' })}</strong>
                </p>
              </div>
              {/* Dauer-Badge */}
              <div className="Font-S-I-130-T Colors-Accent-01 travel-duration-badge">
                <Bus size={20} color="var(--Colors-Accent-01)" />
                <span>{travelPlan.duration_text} Dauer</span>
              </div>
            </div>
          </div>

          {/* Ziel */}
          <div className="timeline-item timeline-item--last">
            <div className="timeline-icon">
              <Fin size={20} />
            </div>
            <div className="timeline-line"/>
            <div className="timeline-content timeline-content--last">
              <span className="Font-S-B-130-T Colors-Grey-06">Ziel</span>
              <p className="Font-M-I-130-T Color-Black">{travelPlan.destination_address}</p>
              <p className="timeline-meta Font-S-B-130-T Colors-Grey-06">
                Zieladresse
                <span className="timeline-divider">|</span>
                Ankunft: <strong>{new Date(travelPlan.arrival).toLocaleString('de-CH', { hour: '2-digit', minute: '2-digit' })}</strong>
              </p>
            </div>
          </div>
        </div>

        </>
      )}
    </div>
  );
};

export { OeVConnectionDisplay };
